<template>
    <div class="vh-full dvfinish">
        <div class="frbox vh-flex">
            <div class="vh-full vh-flex infr1">
                <h1 class="lbfntitle">本轮学习结束</h1>
                <div class="frtime">
                    <div class="lblearntime">
                        <span>学习时长</span>
                        <span>13分钟</span>
                    </div>
                </div>
                <!--插画-->
                <div class="vh-full frimg">
                    <LearnOverCard1></LearnOverCard1>
                </div>
                <!--底部按钮组-->
                <div class="frbot">
                    <div @click="emitEvent('leave')" class="bnt-leave focus-s">
                        <SvgIcon svgname="ic_arleft" fill="white" :size="18"></SvgIcon>
                        <span class="mgl5">离开</span>
                    </div>
                    <div @click="emitEvent('restart')" class="bnt-sea focus-s">
                        <SvgIcon svgname="ic_retry2" fill="var(--ek-color-primary)" :size="18"></SvgIcon>
                        <span class="mgl5">再来一遍</span>
                    </div>
                    <div @click="emitEvent('nextChapter')" class="bnt-sea focus-s">
                        <SvgIcon svgname="ic_right" fill="var(--ek-color-primary)" :size="18"></SvgIcon>
                        <span class="mgl5">下一章</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LearnOverCard1 from '@/components/illustration/LearnOverCard1.vue';
import SvgIcon from '@/components/SvgIcon.vue';
export default {
    name: 'SpellLearnFinish',
    components: {
        LearnOverCard1,
        SvgIcon
    },
    props: {

    },
    methods:{
        ///提交事件
        emitEvent:function(name,data){
            var req = {
                name:name,
                data:data
            }
            this.$emit("eventHandle",req)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bnt-sea {
    margin-left: 20px;
    border: 2px solid var(--ek-color-primary);
    display: flex;
    align-items: center;
    padding-left: 25px;
    padding-right: 25px;
    height: 37px;
    border-radius: 20px;
    color: var(--ek-color-primary);
}

.infr1 {
    margin: 30px;
}

.frbot {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
}

.frtime {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.lblearntime {
    /* background: var(--ek-card-color2); */
    padding-left: 20px;
    padding-right: 20px;
    line-height: 30px;
    font-size: 14px;
    border-radius: 20px;
    color: var(--ek-text-color2);
}

.lbfntitle {
    text-align: center;
    color: var(--ek-text-color1);
    margin-top: 20px;
}

.frimg {
    display: flex;
    justify-content: center;
    align-items: center;
}

.dvfinish {
    display: flex;
    justify-content: center;
    align-items: center;
}

.frbox {
    width: 50%;
    background: var(--ek-mainbody-bgcolor);
    height: 80%;
    border-radius: 30px;
}

.bnt-leave {
    background: var(--ek-color-primary);
    color: white;
    padding-left: 25px;
    padding-right: 25px;
    display: flex;
    align-items: center;
    height: 40px;
    font-size: 15px;
    border-radius: 20px;
}
</style>
